/*  MUI  */
import { Box, Tab } from '@mui/material';

/*  Shared  */
import { MUITabsWrapper } from 'application/Shared/Components/MUITabsWrapper';
import { FontSizes } from 'application/Shared/Constants';
import { ReportConfigCheckboxes } from 'application/Shared/types/reports';

/* Hooks */
import { useReportParams } from 'hooks/useReportParams';

/*  React  */
import React, { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { buildSubReportsSelection } from '../helpers';

export const ChosenReportHeaderTabs = ({
    handleTabChange,
    tab
}: {
    handleTabChange: (_: SyntheticEvent, value: string) => void;
    tab: string;
}) => {
    const { t } = useTranslation();
    const { reportType } = useParams();

    const parsedReportParams = useReportParams(reportType);

    const { type, reportSelections } = parsedReportParams;

    const subReports = buildSubReportsSelection({ reportSelections, type });

    if (!subReports || (subReports?.length && subReports?.length < 2))
        return null;

    return (
        <Box data-trackid="chosenReportTabs">
            <MUITabsWrapper
                className="hidePrint"
                value={tab}
                onChange={handleTabChange}
            >
                {subReports.map((subReport: ReportConfigCheckboxes) => {
                    const subReportType = subReport.type;
                    return (
                        <Tab
                            key={`tab_${subReportType}`}
                            value={subReportType}
                            label={
                                <span
                                    style={{
                                        alignItems: 'center',
                                        display: 'flex',
                                        fontSize: FontSizes[3]
                                    }}
                                >
                                    {t(
                                        `Reports.${type}.checkbox.${subReportType}`
                                    )}
                                </span>
                            }
                            aria-label={t(
                                `Reports.${type}.checkbox.${subReportType}`
                            )}
                            data-trackid={`reports_chosenReport_${subReportType}`}
                        />
                    );
                })}
            </MUITabsWrapper>
        </Box>
    );
};
